import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./OfferCards.css"; // ✅ make sure this file exists for styling

const OfferCards = () => {
  const [offers, setOffers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://www.actrofiteinfotech.com/rootservices/backend/offerslist/get-offers-main.php")
      .then((res) => res.json())
      .then((data) => {
        setOffers(data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching offers:", err);
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div className="loader">Loading...</div>;
  }

  return (
    <div className="offers-wrapper">
      <h2 className="heading">Explore Offers</h2>
      <div className="offers-container">
        {offers.map((item) => (
          <Link
            key={item.id}
            to={`/offercard2/${item.id}`}  // ✅ corrected template literal
            className="offer-card"
          >
            <img 
              src={item.image_url} 
              alt={item.title} 
              className="offer-image" 
            />
            <p className="offer-title">{item.title}</p>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default OfferCards;
